import {Injectable} from '@angular/core';
import {ResolveEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";

@Injectable()
export class RouteUrlHistoryService {

  private readonly _urlHistory: string[];

  constructor(
    private _router: Router
  ) {
    this._urlHistory = [];

    this._router.events
      .pipe(filter((event: any) => event instanceof ResolveEnd))
      .subscribe((event: ResolveEnd): void => {
        this._urlHistory.push(event.url);
      });
  }

  public getUrlHistory(): string[] {
    return this._urlHistory;
  }

  public getPreviousRouteUrl(): string {
    if (this._urlHistory.length < 2) {
      return null;
    }

    return this._urlHistory[this._urlHistory.length - 2];
  }

  public getCurrentRouteUrl(): string {
    if (this._urlHistory.length < 1) {
      return null;
    }

    return this._urlHistory[this._urlHistory.length - 1];
  }

}
